import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";

export function AuditDialog({ activity: a, onClose }) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/takip/activities/${a.id}/audit`).then(({ data }) => setItems(data.items)).catch((e) => setErr(apiError(e))); }, [a.id]);
  const show = (v) => (v == null || v === "" ? "—" : String(v));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="activity-audit-dialog">
        <DialogHeader><DialogTitle>Değişiklik Ayrıntısı</DialogTitle></DialogHeader>
        <div className="text-[12px] text-slate-500 mb-2">{formatDate(a.ts)} · {a.user_name} · {a.summary}</div>
        {err ? <div className="text-rose-700 text-sm">{err}</div> : !items ? <Loader2 className="h-4 w-4 animate-spin text-blue-600" /> : items.length === 0
          ? <div className="text-sm text-slate-400" data-testid="activity-audit-empty">Bu işlem için denetim kaydı bulunamadı.</div> : (
          <table className="erp-table"><thead><tr><th>Kayıt</th><th>Alan</th><th>Eski</th><th>Yeni</th></tr></thead>
            <tbody>{items.map((r, i) => (
              <tr key={i} data-testid="activity-audit-row"><td className="text-xs">{r.entity}<div className="text-[10px] text-slate-400">{r.note}</div></td>
                <td className="text-xs font-mono">{r.field}</td>
                <td className="text-xs text-slate-400 line-through max-w-[200px] break-words">{show(r.old)}</td>
                <td className="text-xs max-w-[200px] break-words">{show(r.new)}</td></tr>))}</tbody></table>)}
      </DialogContent>
    </Dialog>
  );
}
